var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%","box-sizing":"border-box"}},[_c('my-nav-bar',{attrs:{"title":"康复直播"}}),_c('iframe',{staticStyle:{"width":"100%","border":"0px","margin":"0","display":"none"},attrs:{"id":"“frame”","src":"https://wx.vzan.com/live/livedetail-265220304"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }